import { Card } from '@journ/ui/card'
import { useMemo } from 'react'
import { useIntlayer } from 'react-intlayer'
import { useSelector } from '@/libs/state'
import { session$ } from '@/features/auth/store'
import { useBalances } from '../hooks/use-balances'
import { useMembers } from '../hooks/use-members'

const cardClassName =
	'p-5 flex flex-col justify-between bg-background border-e6e6e6 rounded-none min-h-[90px]'

const TimeOffBalanceSummary = () => {
	const content = useIntlayer('hr-page')
	const b = content.timeOff.balances
	const to = content.timeOff

	const { balances } = useBalances()
	const { members } = useMembers(null, null)
	const user = useSelector(() => session$.user.get())

	const ownMemberId = useMemo(() => members.find(m => m.email === user?.email)?.id ?? null, [members, user?.email])

	const ownBalances = useMemo(() => balances.filter(bal => bal.memberId === ownMemberId), [balances, ownMemberId])

	if (ownBalances.length === 0) return null

	return (
		<div className='grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3'>
			{ownBalances.map(item => (
				<Card key={`${item.memberId}-${item.type}`} className={cardClassName}>
					<span className='text-xs text-muted-foreground'>{to.requestType[item.type]?.value ?? item.type}</span>
					<div className='mt-3'>
						<span className='text-xl font-medium'>{item.available}</span>
						<span className='text-xs text-muted-foreground ml-1.5'>{b.days}</span>
						{(item.taken > 0 || item.pending > 0) && (
							<p className='text-xs text-muted-foreground mt-1'>
								{item.taken > 0 && `${b.taken}: ${item.taken}`}
								{item.taken > 0 && item.pending > 0 && ' · '}
								{item.pending > 0 && `${b.pending}: ${item.pending}`}
							</p>
						)}
					</div>
				</Card>
			))}
		</div>
	)
}

export { TimeOffBalanceSummary }
